import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { config as runtimeConfig } from "../runtime-config";

type SyncStatus = {
  last_success_at: string | null;
  age_seconds: number | null;
  is_stale: boolean;
  stale_threshold_seconds: number;
};

// Freshness is non-PII — call without a bearer token to avoid forcing an
// MSAL silent iframe flow every 60s just to render a banner.
async function fetchSyncStatus(): Promise<SyncStatus> {
  const res = await fetch(`${runtimeConfig.apiBaseUrl}/api/sync-status`);
  if (!res.ok) throw new Error(`sync_status_${res.status}`);
  return (await res.json()) as SyncStatus;
}

export function SyncBanner() {
  const { t, i18n } = useTranslation();
  const { data } = useQuery({
    queryKey: ["sync-status"],
    queryFn: fetchSyncStatus,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  });

  if (!data?.is_stale) return null;

  const minutes = data.age_seconds != null ? Math.floor(data.age_seconds / 60) : null;
  const when = data.last_success_at
    ? new Date(data.last_success_at).toLocaleString(
        i18n.language.startsWith("fr") ? "fr-FR" : "en-GB",
        { dateStyle: "short", timeStyle: "short" },
      )
    : null;

  return (
    <div className="stale-banner" role="status" aria-live="polite">
      <strong>{t("errors.outdated")}</strong>
      {when != null && (
        <span className="stale-detail">
          {" "}
          {t("errors.outdatedDetail", { when, minutes })}
        </span>
      )}
    </div>
  );
}
